<h2 mat-dialog-title>{{ data.title }}</h2>

<mat-dialog-content>
  @if (data.amount !== undefined) {
  <div class="amount-box">
    <div>
      <span class="amount-label">Amount to pay (Toman)</span>
      <span class="amount-value">{{ data.amount | number }}</span>
      @if (data.summary) { <span class="amount-summary">{{ data.summary }}</span> }
    </div>
    <app-copy-rial-button [amount]="data.amount"></app-copy-rial-button>
  </div>
  } @else if (data.summary) {
  <p class="hint">{{ data.summary }}</p>
  }

  <p class="hint">
    This only records what was paid. Proof images are optional and can be added later.
  </p>

  @if (data.askPayment) {
  <app-payment-source-fields [details]="payment"></app-payment-source-fields>
  }

  <form [formGroup]="form" class="proof-form">
    <mat-form-field appearance="outline" class="w-full">
      <mat-label>Note</mat-label>
      <input matInput formControlName="note" placeholder="Optional note">
    </mat-form-field>

    <div class="file-row">
      <button mat-stroked-button type="button" [disabled]="proofs.length >= room" (click)="fileInput.click()">
        <mat-icon>attach_file</mat-icon> Attach payment proof
      </button>
      <input #fileInput type="file" [accept]="accept" multiple hidden (change)="onFilesSelected($event)">
      <span class="file-count">{{ proofs.length }} / {{ room }}</span>
    </div>

    @if (fileError) {
    <p class="file-error">{{ fileError }}</p>
    }

    @if (proofs.length) {
    <div class="previews">
      @for (p of proofs; track p.url; let i = $index) {
      <div class="preview-tile">
        <img [src]="p.url" [alt]="p.file.name">
        <button mat-icon-button type="button" class="remove" matTooltip="Remove" (click)="removeFile(i)">
          <mat-icon>close</mat-icon>
        </button>
      </div>
      }
    </div>
    }
  </form>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button (click)="onCancel()">Cancel</button>
  <button mat-raised-button color="primary" [disabled]="!canSubmit" (click)="onSubmit()">{{ data.submitLabel }}</button>
</mat-dialog-actions>
